"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var factory_1 = require("../../factory");
function getLocales() {
    return new Promise(function (resolve) {
        resolve({
            'languages': getUserLanguage(),
            'timezone': getUserTimezone()
        });
    });
}
function getUserLanguage() {
    var userLanguages = [];
    return navigator.language;
}
function getUserTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
(0, factory_1.includeComponent)('locales', getLocales);
//# sourceMappingURL=locales.js.map